import Screen from './screen';
import template from './templates/yesno.html';
export class YesNoScreen extends Screen {
    constructor(name, uic) {
        super(name, uic);
        this.elements = {};
    }
    bootstrapScreen(chatWindowElement) {
        let mainDivId = 'cbot-yesno-' + this.name;
        let yesnoscreen = $.parseHTML(template);
        $(yesnoscreen).attr('id', mainDivId);
        chatWindowElement.append(yesnoscreen);
        this.elements['mainDiv'] = $('#' + mainDivId);
        this.elements['text1'] = $('#' + mainDivId).find('.js-text1');
        this.elements['text2'] = $('#' + mainDivId).find('.js-text2');
        this.elements['text3'] = $('#' + mainDivId).find('.js-text3');
        this.elements['btnYes'] = $('#' + mainDivId).find('.js-btn1');
        this.elements['btnNo'] = $('#' + mainDivId).find('.js-btn2');
        this.elements['btnContainer'] = $('#' + mainDivId).find('.cbot-yesno-button-container');
        this.elements['close'] = $('#' + mainDivId).find('.js-chat-close');
    }
}
